import { GridRenderEditCellParams, useGridApiContext } from '@mui/x-data-grid';
import { FormProvider, useForm } from 'react-hook-form';
import moment, { Moment } from 'moment-timezone';
import { useTranslation } from 'react-i18next';
import { InputDatePicker } from '../../pickers';

const CustomEditDatePicker = (props: GridRenderEditCellParams) => {
  const { id, field, value } = props;
  const { t } = useTranslation('timesheets');

  const apiRef = useGridApiContext();

  const methods = useForm({
    mode: 'all',
    values: {
      date: value,
    },
  });

  const handleChange = (date: Moment | null) => {
    apiRef.current?.setEditCellValue({
      id,
      field,
      value: date,
    });
  };

  return (
    <FormProvider {...methods}>
      <InputDatePicker
        minDate={moment()}
        onChange={handleChange}
        placeholder={t('date')}
        name="date"
        size="medium"
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: 0,
          },
          '& .MuiInputBase-input': {
            borderRadius: 0,
          },
        }}
      />
    </FormProvider>
  );
};

export {
  CustomEditDatePicker,
};
